export enum FilterTypes {
  Contains = 0,
  NotContain = 1,
  Equals = 2,
  NotEquals = 3,
  GreaterThan = 4,
  GreaterThanOrEqual = 5,
  LessThan = 6,
  LessThanOrEqual = 7,
  In = 8,
}

export enum FilterInputType {
  Text = 0,
  Number = 1,
  Date = 2,
  Select = 3,
  Reference = 4,
  Bool = 5,
  AutoComplete = 6,
  AutoCompleteArray = 7,
}
